import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-simple-layout',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './simple-layout.component.html',
  styleUrl: './simple-layout.component.scss',
})
export class SimpleLayoutComponent {}
